import uuid from '@ali/xutil/uuid';
import defer from '@ali/xutil/defer';
import Context from './context';

class BaseInvoker {

  static type = '';
  static sync = false;
  static instancePool = {};
  static middlewares = [];

  static use(ware) {
    this.middlewares.push(ware);
    return this;
  }

  id = this.uuid();
  context = null;

  constructor(options) {
    this.__X__ = options.__X__;
    this.context = new Context(options);
    this.constructor.instancePool[this.id] = this;
  }

  uuid() {
    return uuid();
  }

  call() {
    let i = 0;
    let {context} = this;
    let middlewares = this.constructor.middlewares;
    let deferred = defer();

    let next = (error) => {
      let middleware = middlewares[i];

      if (error) {
        context.error = context.error || error; // 只保留最早发生的 error
      }

      if (!middleware) {
        return this.end(deferred);
      }

      // some middleware info to context
      context.middleware = {
        index: i,
        fn: middleware,
      };

      i++;

      try {
        middleware(context, next);
      } catch(ex) {
        next(ex);
      }
    };

    next();

    return deferred.promise;
  }

  end(deferred) {
    let {context} = this;
    // avoid ending multiple times
    if (!context) return;
    let {response, error, callback} = context;

    if (error) {
      callback.error && callback.error(error);
      deferred.reject(error);
    } else {
      callback.success && callback.success(response.body);
      deferred.resolve(response.body);
    }

    this.destroy();
  }

  destroy() {
    delete this.constructor.instancePool[this.id];
    // this.context.destroy();
    for (let key in this) {
      if (!this.hasOwnProperty(key)) continue;
      delete this[key];
    }
  }
}

export default BaseInvoker;

export function createInvoker(type) {
  return class Invoker extends BaseInvoker {
    static type = type;
    static sync = false;
    static middlewares = [];

    constructor(...args) {
      super(...args);
    }
  };
}



// WEBPACK FOOTER //
// ../x/packages/core/src/invoker.async.js